function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var getNextItem = function getNextItem(intersections) {
  var _intersections;
  var lastItemDisplayedIndex = _toConsumableArray(intersections).reverse().findIndex(function (intersection) {
    return (intersection === null || intersection === void 0 ? void 0 : intersection.intersectionRatio) === 1;
  });
  return (_intersections = intersections[intersections.length - lastItemDisplayedIndex]) !== null && _intersections !== void 0 ? _intersections : null;
};
export var hasNextItem = function hasNextItem(intersections) {
  var lastItem = intersections[intersections.length - 1];
  return (lastItem === null || lastItem === void 0 ? void 0 : lastItem.intersectionRatio) !== 1;
};
export var isNextItem = function isNextItem(intersections, element) {
  var nextItem = getNextItem(intersections);
  return (nextItem === null || nextItem === void 0 ? void 0 : nextItem.target) === element;
};
export var getPreviousItem = function getPreviousItem(intersections) {
  var _intersections2;
  var firstDisplayedIndex = intersections.findIndex(function (intersection) {
    return (intersection === null || intersection === void 0 ? void 0 : intersection.intersectionRatio) === 1;
  });
  return (_intersections2 = intersections[firstDisplayedIndex - 1]) !== null && _intersections2 !== void 0 ? _intersections2 : null;
};
export var hasPreviousItem = function hasPreviousItem(intersections) {
  var firstItem = intersections[0];
  return (firstItem === null || firstItem === void 0 ? void 0 : firstItem.intersectionRatio) !== 1;
};
export var isPreviousItem = function isPreviousItem(intersections, element) {
  var previousItem = getPreviousItem(intersections);
  return (previousItem === null || previousItem === void 0 ? void 0 : previousItem.target) === element;
};
export var hasNavigation = function hasNavigation(intersections) {
  return hasPreviousItem(intersections) || hasNextItem(intersections);
};
export var LEFT_OFFSET = 48;
export var RIGHT_OFFSET = 48;
export var getNextPosition = function getNextPosition(currentPosition, wrapper, intersections) {
  var nextItem = getNextItem(intersections);
  if (nextItem) {
    return currentPosition + (nextItem.target.getBoundingClientRect().right - wrapper.getBoundingClientRect().right + RIGHT_OFFSET);
  }
  return false;
};
export var getPreviousPosition = function getPreviousPosition(currentPosition, wrapper, intersections) {
  var previousItem = getPreviousItem(intersections);
  if (previousItem) {
    return Math.max(0, currentPosition - (wrapper.getBoundingClientRect().left - previousItem.target.getBoundingClientRect().left + LEFT_OFFSET));
  }
  return false;
};